const SELECTOR = ".btn-primary, .btn-dash-primary"

function start(event) {
  const button = event.submitter

  if (event.defaultPrevented || !button?.matches(SELECTOR) || button.dataset.spinner === "false") return

  button.classList.add("is-submitting")
  setTimeout(() => { button.disabled = true })
}

function reset() {
  document.querySelectorAll(".is-submitting").forEach((button) => {
    button.classList.remove("is-submitting")
    button.disabled = false
  })
}

export function initSubmitSpinner() {
  document.addEventListener("submit", start)
  window.addEventListener("pageshow", (event) => { if (event.persisted) reset() })
  document.addEventListener("turbolinks:before-cache", reset)
}
